<template>
   
    <div class="wrapper" style="background-color: #f1f2f6;">
        <Sidebar />

        <div class="container container-fix" :style="{ 'margin-left': sidebarWidth }">
            <form class="row">

                <div class="title col-12 text-center" style="font-size:26px; margin-top:40px; font-weight:800;">Create A Contract For Your Sub-Contractor</div>

                <div class="title col-12 text-center"> Please input the following information in the fields below to generate a contract to send to your Sub-Contractor  </div>
        
                <div class="col-12 col-sm-6 text-center">
                    <label class="form-label"> Commencement Date<span class="mandatory">*</span></label>
                    <div>
                        <date-picker :disabled-date="disabledBeforeToday" :value="Contract.CommencementDate" valueType="format"  format="YYYY-MM-DD" @change="(x)=>{setCommencementDate(x);}"></date-picker>
                    </div>
                </div>
                <div class="col-12  col-sm-6 text-center">
                    <label class="form-label"> Completion Date<span class="mandatory">*</span></label>
                    <div>
                        <date-picker :disabled-date="disabledBeforeToday" :value="Contract.CompletionDate" valueType="format"  format="YYYY-MM-DD" @change="(x)=>{Contract.CompletionDate = x}"></date-picker>
                    </div>

                </div>


                <div class="title col-12"> Make contract comments for sub-contractor <span class="mandatory">*</span><span style="color:red; font-size:12px;"></span></div>
                
                <div class="col-12 text-center" style="margin-bottom: 8px; margin-top: -8px;">

                    <n-popselect :options="ExampleOptions" trigger="click">
                        <div style="text-decoration:underline; cursor:pointer; color:blue; font-size:12px;">Example of what you should write here</div>

                    </n-popselect>

                </div>

                <div class="col-12">

                    <TextEditorWithAI
                            v-model:text="Contract.ScopeOfServices"
                            placeholder="Description"
                            @showLoader="showLoader"
                            @hideLoader="hideLoader"
                            />

                </div>

                <div class="title col-12"> Payment Terms </div>

                <div class="col-12">

                    <PaymentTerms :initial-data="paymentTermsData || {}" ref="paymentTermsComponent" :type="0" :StartDate="formatedStartDate"/>
                </div>

                <div class="col-12">
                    <div class="title col-12" style="padding: 0px; margin-top: 24px;">
                        The address where you want this Sub-Contractor to provide their service is at;
                    </div>
                    <div class="col-12" style="font-size: 12px;" >
                        (you may edit this if this is not the correct location)
                    </div>
                    <textarea style="margin-top: 16px; height: 100px;" v-model="address" class="form-control" placeholder="Serivce Address" />
                </div>

                <div class="col-12">
                    <!--type 1 for client terms, type 0 for sub terms-->
                    <Terms :initial-data="termsData || {}" ref="termsComponent" :type="0" :TermsId="TermsId" @updateShowAddTerms="updateShowAddTerms" />
                </div>

                <div class="col-12 expiry-date" >
                    Unless signed by your recipient/s, this contract will expiry on <date-picker :disabled-date="disabledBeforeTodayAndStartDate"  :value="ExpiredTime" valueType="format" format="YYYY-MM-DD" @change="(x)=>{ExpiredTime = x}"></date-picker>
                </div>

                <div class="col-12 btn-bar" >
                    <div class="btn btn-nagative" style="width: 130px;" @click="back">Cancel</div>
                     <div class="btn btn-positive" style="width: 170px;" @click="saveAsDraft(false)">Save As Draft</div>
                    <div class="btn btn-positive" style="width: 170px;" @click="addTerms" v-if="showAddTerms">Add A New Term</div>
                    <div class="btn btn-positive" style="width: 170px;" @click="getPaymentTermsData">Review Contract</div>
                </div>
            </form>

            <ContractPreviewModal ref="preview" v-show="showPreviewModal" @close-preview-modal="showPreviewModal = false" @send="sendContract" />
              
        </div>
        <CustomPopup
          :visible="showPopup"
          :icon="popupIcon"
          :iconSrc="popupIconSrc"  
          :iconColor="iconColor"
          :title="popupTitle"
          :content="content"
          :cancelText="cancelText"
          :confirmText="confirmText"
          :confirmButtonType="confirmButtonType"
          :confirmAction="currentConfirmAction"
           :cancelAction="cancelAction"
          :autoClose="autoClose"
          @cancel="onCancel"
        />  
       
    </div>
</template>

<script>
    import DatePicker from 'vue-datepicker-next';
    import 'vue-datepicker-next/index.css';
    import ContractPreviewModal from '../components/modals/ContractPreviewModal.vue';
    import Sidebar from '../components/siderbar/SidebarComponent';
    import { sidebarWidth } from '../components/siderbar/state';
    import PaymentTerms from '../components/PaymentTermsComponent';
    import Terms from '../components/TermsComponent';

    import  TextEditorWithAI from "../components/TextEditorWithAI.vue";

    import CustomPopup from '../components/modals/CustomPopup.vue';

    export default {
        components: {
            DatePicker, ContractPreviewModal, Sidebar, PaymentTerms, Terms, TextEditorWithAI, CustomPopup
        },
        setup() {
            return { sidebarWidth }
        },
        data() {
            return {
                showPreviewModal: false,
                Contract: {                 
                    ServiceType: "",
                    CommencementDate: "",
                    CompletionDate: "",
                    ScopeOfServices: "",
                    Payment: {},
                    Terms: [],
                    TermsId: '00000000-0000-0000-0000-000000000000',
                    Address: "",
                    
                },

                address: "",

                ExpiredTime: this.formatDate(new Date(new Date().getTime() + 24 * 60 * 60 * 1000)),

                ServiceTypes : [],
                TermsId: '00000000-0000-0000-0000-000000000000',
                Terms: [
                    
                ],

                termsData: {},

                //test payment terms data
                paymentTermsData: {

                },

                TermsOptions: [],
                selectedTemplateId: '',

                ExampleOptions: [
                    { label: "-Demo entire kitchen", value: "-Demo entire kitchen" },
                    { label: "-Remove partition wall between kitchen and living room", value: "-Remove partition wall between kitchen and living room" },
                    { label: "-Relocate all electrical and plumbing including 2 new 20 amp service lines", value: "-Relocate all electrical and plumbing including 2 new 20 amp service lines" },
                    { label: "-Install 800 SF hardwood floors (Oak colour 4 inch wide * 3/4inch)", value: "-Install 800 SF hardwood floors (Oak colour 4 inch wide * 3/4inch)" },
                    { label: "-Install 200 SF Carrera marble floors (2 feet * 4 Feet size)", value: "-Install 200 SF Carrera marble floors (2 feet * 4 Feet size)" },
                    { label: "-Install new kitchen cabinets (Benjamin Moore Phillsburg Blue Colour)", value: "-Install new kitchen cabinets (Benjamin Moore Phillsburg Blue Colour)" },
                    { label: "-Install 8 pot lights (LED 3000 Colour)", value: "-Install 8 pot lights (LED 3000 Colour)" },
                ],

                showAddTerms: true,


                formatedStartDate: "",
                 //Custom Popup
                showPopup: false,
                popupIcon: null, // Set to null since we'll use an image
                popupIconSrc: '', // Use this variable to hold the image path
                iconColor: '',
                popupTitle: '',
                content: '',
                cancelText: '',
                confirmText: '',
                confirmButtonType: 'primary',
                currentConfirmAction: null,
                 cancelAction: null,
                autoClose: false,
            }
        },
        mounted() {
            //this.getServiceTypes();
            //this.getTerms();
            this.$refs.paymentTermsComponent.initData(this.paymentTermsData);

            this.address = this.$core.data.SelectedProjectAddress;

            this.ExpiredTime = this.formatDate(new Date(new Date().getTime() + 48 * 60 * 60 * 1000));
 
        },

        methods: {

            updateShowAddTerms(val) {
                //console.log("updateShowAddTerms", val);
                this.showAddTerms = val;
            },

            showLoader(){
                this.$loader.show(null, 30);
            },
            hideLoader(){
                this.$loader.hide();
            },

            setCommencementDate(date) {

                if(date == null || date.length == 0) {
                    this.Contract.CommencementDate = "";
                    return;
                }

                var obj = this.$refs.paymentTermsComponent.finish();

                //console.log("getPaymentTermsData", obj);
                if(obj.Mode == 'date' && obj.Terms !=null && obj.Terms.length > 0){
                    //console.log("getPaymentTermsData 123", obj.Terms);
                    if(obj.Terms[0].name!=null && obj.Terms[0].name.length > 0){
                        var firstDate = new Date(obj.Terms[0].name);
                        //console.log("firstDate", firstDate);

                        var _date = new Date(date);
                        try{
                            if(firstDate.getTime() < _date.getTime()){
                                this.alertMessage("The commencement date cannot be after the payment date.");
                                return;
                            }
                        }catch(e){
                            console.error(e);
                        }
                        
                    }
                }

                this.Contract.CommencementDate = date;
                //console.log("setCommencementDate", new Date(date).toISOString().split("T")[0]);
                this.formatedStartDate = new Date(date).toISOString().split("T")[0];
                this.getExpiryDate(date);

                },


                checkTermsBeforeSend(callback, isDraft = false) {
                //console.log("checkTermsBeforeSend", this.isTermsChanged);

                var data = this.$refs.termsComponent.getCurrentTermsData();
                    
                console.log("checkTermsBeforeSend", data);

                var IsChanged = data.IsChanged;

                if(!IsChanged) {
                    if(callback)
                        callback(true);
                  
                }else{

                    
                    data = this.$refs.termsComponent.getCurrentTermsData();
                    
                    //console.log("checkTermsBeforeSend", data);
                    

                    this.iconColor = 'red';
                    this.popupIconSrc = null // Replace with your image path
                    this.popupTitle = 'Terms Changed';
                    if(isDraft) {
                        this.content = 'You have made changes to your Contract Template "' + data.Tag + '". Would you like to save these changes for future use?';
                        this.cancelText = 'SAVE AS DRAFT AND ON TEMPLATE';
                        this.confirmText = 'SAVE AS DRAFT ONLY FOR THIS CONTRACT';

                        this.currentConfirmAction = () => callback(true);
                        this.cancelAction = () => this.saveTemplate(callback, data);
                    }else{
                        this.content = 'You have made changes to your Contract Template "' + data.Tag + '". Would you like to save these changes for future use?';
                        this.confirmText = 'SAVE CHANGES AND REVIEW';
                        this.cancelText = 'NO JUST REVIEW';

                        this.currentConfirmAction = () => this.saveTemplate(callback, data);
                        this.cancelAction = () => callback(true);
                    }
                    
                    this.confirmButtonType = 'success';
                   
                    this.showPopup = true;

                    this.autoClose = false;
                }
            },

            saveTemplate(callback, data) {

                //console.log("saveTemplate");
 
                //console.log(data);
 
                //this.$loader.show(null, 30);
                
                this.$http.request("put", "/api/app/customterm/update", data).then(res => {
                    console.log("update custom term", res);
                    if (res?.Type == 200) {
                        if(callback)
                            callback(true);
                    }else{
                        this.alertMessage(res?.Content);
                    }
                }).finally(() => {
                    //this.$loader.hide();
                });
                
            },

            saveAsDraft(checked = false) {


                const dataObj = this.$refs.paymentTermsComponent.finish();

                this.Contract.Payment = dataObj;

                if (this.Contract.CommencementDate == null || this.Contract.CommencementDate.length == 0) {
                    this.alertMessage("Please choose a anticipated Commencement Date for this project");
                    return;
                }

                if (this.Contract.CompletionDate == null || this.Contract.CompletionDate.length == 0) {
                    this.alertMessage("Please choose an anticipated completion date for this project.");
                    return;
                }

                if (this.Contract.ScopeOfServices == null || this.Contract.ScopeOfServices.length == 0) {
                    this.alertMessage("Please enter a detailed description of this project.");
                    return;
                }

                if (this.Contract.Payment.TotalCost == 0) {
                    this.alertMessage("Please Define Payment Terms");
                    return;
                }


                if(!checked){
                    this.checkTermsBeforeSend(this.saveAsDraft, true);
                    return;
                }

                 
                //this.Terms = newTerms;
                this.Contract.Terms = this.$refs.termsComponent.getCurrentTerms();
                this.Contract.TermsId = this.$refs.termsComponent.getTermsId();  
                //console.log(JSON.stringify(this.Contract.Terms));

               var data = {};

               
                this.Contract.ServiceAddress = this.address ;

                data.Data = JSON.stringify(this.Contract);
                data.Type = 0;
                data.UserId = this.$core.data.UserInfo.Id;
                data.ProjectId = this.$route.params.projectid;
                data.PartyBId = this.$route.params.subcontractorid;

                data.ExpiredTime = this.ExpiredTime;
                data.Attachments = this.$refs.termsComponent.getAttatchmetsData();

               console.log("Save As Draft data ====>", JSON.stringify(data));


                this.$loader.show(null, 30);
                this.$http.request("post", "/api/app/contract/savedraft", data).then(res => {

                    console.log("Save As Draft res ====>", res);
                    if (res?.Type == 200) {
                         
                        this.iconColor = 'red';
                        this.popupIconSrc = null // Replace with your image path
                        this.popupTitle = "Success";
                        this.content = "Contract Saved As Draft!";
                        this.cancelText = null;
                        this.confirmText = 'OK';
                        this.confirmButtonType = 'success';
                        this.currentConfirmAction = () => {
                            this.$router.back();
                        };
                        
                        this.autoClose = true;

                        this.showPopup = true;
                    }else{
                        this.alertMessage(res?.Content);
                    }
                }).finally(() => {
                    this.$loader.hide();
                });
            },

            getExpiryDate(date){

                if(date == null || date.length == 0) return;

                this.$http.request("get", "/api/app/contract/getexpiredtime", {date: date}).then(res => {
                    
                    if (res?.Type == 200) {
                         this.ExpiredTime = res?.Data;
                    }
                }) ;
            },

            getPaymentTermsData() {

                const dataObj = this.$refs.paymentTermsComponent.finish();

                if (dataObj.Remain != 0 && dataObj.Mode != 'custom') {
                    this.alertMessage("Please ensure that the 'Remaining Amount' under 'Payment Terms' is no more than '0' (zero) after setting the payment date.");
                    return;
                }

                this.Contract.Payment = dataObj;


                // Handle the dataObj here
                //console.log('Received dataObj:', this.Contract);

                this.review(false);

            },
            addTerms() {
                
                this.$refs.termsComponent.addTerms();

            },
            changeServiceType() {

            },
            getServiceTypes() {
                this.$http.request("get", "/api/app/servicetype/readlist").then(res => {
                    if (res?.Type == 200) {
                        this.ServiceTypes = res.Data;
                    }
                });
            },
          
            review(checked = false) {

                //check data mandatory.
                if (this.Contract.CommencementDate == null || this.Contract.CommencementDate.length == 0) {
                    this.alertMessage("Please choose a Commencement Date for this project");
                    return;
                }

                if (this.Contract.CompletionDate == null || this.Contract.CompletionDate.length == 0) {
                    this.alertMessage("Please choose an anticipated completion date for this project.");
                    return;
                }

                if (this.Contract.ScopeOfServices == null || this.Contract.ScopeOfServices.length == 0) {
                    this.alertMessage("Please enter a detailed description of this project.");
                    return;
                }

                if (this.Contract.Payment.TotalCost == 0) {
                    this.alertMessage("Please enter the total cost of the project");
                    return;
                }


                if(!checked){
                    this.checkTermsBeforeSend(this.review, false);
                    return;
                }

                this.Contract.Terms = this.$refs.termsComponent.getCurrentTerms();
                this.Contract.TermsId = this.$refs.termsComponent.getTermsId();  


                var data = {};

                this.Contract.ServiceAddress = this.address ;

                data.Data = JSON.stringify(this.Contract);
                data.Type = 0;
                data.UserId = this.$core.data.UserInfo.Id;
                data.ProjectId = this.$route.params.projectid;
                data.PartyBId = this.$route.params.subcontractorid;

                data.ExpiredTime = this.ExpiredTime;
                data.Attachments = this.$refs.termsComponent.getAttatchmetsData();
                

                //console.log(JSON.stringify(data));
                this.$loader.show(null, 30);
                this.$http.request("post", "/api/app/contract/preview", data).then(res => {
                    if (res?.Type == 200) {
                        this.$refs.preview.iframeContent(unescape(res.Data.Body));
                        this.showPreviewModal = true;
                    }else{
                        this.alertMessage(res?.Content);
                    }
                }).finally(() => {
                    this.$loader.hide();
                });
                  
            },

            sendContract() {
                this.showPreviewModal = false;


                this.Contract.ServiceAddress = this.address ;

                var data = {};
                data.Data = JSON.stringify(this.Contract);
                data.Type = 0;
                data.UserId = this.$core.data.UserInfo.Id;
                data.ProjectId = this.$route.params.projectid;
                data.PartyBId = this.$route.params.subcontractorid;

                data.ExpiredTime = this.ExpiredTime;
                data.Attachments = this.$refs.termsComponent.getAttatchmetsData();

                this.$loader.show(null, 30);
                this.$http.request("post", "/api/app/contract/create", data).then(res => {
                     
                    if (res?.Type == 200) {
                        this.$ui.alert(this, "Success", "Contracts Sent, Please Allow Up To 10 Minutes To Reach The Recipient/s", "success").then(() => {
                            this.$router.back();
                        });
                    }else{
                        this.alertMessage(res?.Content);
                    }

                }).finally(() => {
                    this.$loader.hide();
                });
            },
            back() {
               this.$router.back();
            },

            formatDate(date) {
                var month = '' + (date.getMonth() + 1);
                var day = '' + date.getDate();
                var year = date.getFullYear();

                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;

                return [year, month, day].join('-');
            },
            
            disabledBeforeTodayAndStartDate(date) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                
                if (this.formatedStartDate !=null && this.formatedStartDate.length > 0) {
                    const [year, month, day] = this.formatedStartDate.split('-');
                    const commencementDate = new Date(year, month - 1, day); // Months are 0-indexed

                    //console.log("commencementDate", commencementDate);
                    
                    const isToday = commencementDate.toDateString() === new Date().toDateString();
                    if (!isToday) {                
                        commencementDate.setDate(commencementDate.getDate() - 1);
                    }
                   
                    return date < today || date > commencementDate;
                }

                return date < today;
            },

            disabledBeforeToday(date) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                
                return date < today;
            },


            alertMessage(msg) {              

                //this.popupIcon = 'FieldTimeOutlined';
                this.iconColor = 'red';
                this.popupIconSrc = null // Replace with your image path
                this.popupTitle = msg;
                this.content = null;
                this.cancelText = null;
                this.confirmText = 'OK';
                this.confirmButtonType = 'success';
                this.currentConfirmAction = null;
                this.showPopup = true;

                this.autoClose = false;

            },
            onCancel() {
                this.showPopup = false;
            },
           
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


    .form-check .form-check-input{float:right; margin-left: -1.5em;}
    .form-check-label{padding: 4px; border: 1px solid black; margin-right:20px !important; width:calc(100% - 40px);}
    .form-check {padding-left:.5em; padding-right:0px !important; width: 100%;}
    .info{font-size: 12px; color:black;text-align:center;}
    .container-fix{ max-width: 1080px; padding-left:40px !important;}
    .title{font-size: 14px;}

    .terms-enter-active, .terms-leave-active {
        transition: all 0.5s ease;
    }

    .terms-enter, .terms-leave-to /* .terms-leave-active in <2.1.8 */ {
        opacity: 0;
        transform: translateY(20px);
    }

    .terms-move {
        transition: transform 0.5s ease;
    }
</style>

